// Mapeamento de imagens para os filtros
export const FILTER_IMAGES = {
  // Madeiras
  "peroba rosa": "/assets/images/madeiras/peroba.jpeg",
  "teca": "/assets/images/madeiras/teca.jpg",
  "ipê": "/assets/images/madeiras/ipe.jpg",
  "jeguitiba": "/assets/images/madeiras/jequitiba.jpg",
  "cumaru": "/assets/images/madeiras/cumaru.jpg",

  // Tecidos Premium
  "angra - bege": "/assets/images/tecido-premium/bege.jpeg",
  "angra - beje": "/assets/images/tecido-premium/bege.jpeg",
  "angra - navy": "/assets/images/tecido-premium/navy.jpeg",
  "angra - naivy": "/assets/images/tecido-premium/navy.jpeg",
  "angra - celadon": "/assets/images/tecido-premium/celadon.jpeg",
  "buzios - azul mescla": "/assets/images/tecido-premium/mescla.jpeg",
  "marau - arbusto": "/assets/images/tecido-premium/marau-arbusto.jpeg",
  "marau - arbustro": "/assets/images/tecido-premium/arbusto.jpeg",
  "itaparica - verde": "/assets/images/tecido-premium/verde.jpeg",
  "itaparica - grafiti": "/assets/images/tecido-premium/itaparica-grafiti.jpeg",
  "trancoso - cinza": "/assets/images/tecido-premium/cinza.jpeg",
  "parati - gengibre": "/assets/images/tecido-premium/gengibre.jpeg",
  "angra - bege premium": "/assets/images/tecido-premium/angra-bege.jpeg",
  "angra - navy premium": "/assets/images/tecido-premium/angra-navy.jpeg",
  "grafiti": "/assets/images/tecido-premium/grafiti.jpeg",

  // Tecidos Básicos
  "lisato - beje": "/assets/images/no_image.png",
  "lisato - fendi": "/assets/images/no_image.png",
  "lisato - marinho": "/assets/images/tecidos/lisato-marinho.png",
  "lisato - verde claro": "/assets/images/no_image.png",
  "lisato - oliva": "/assets/images/tecidos/lisato-oliva.jpeg",
  "lisato - cinza claro": "/assets/images/tecidos/lisato-cinza-claro.png",
  "lisato - grafiti": "/assets/images/tecidos/lisado-grafite.jpg",
  "lisato - preto": "/assets/images/tecidos/lisato-preto.png",
  "duna - cru": "/assets/images/tecidos/duna-cru.png",
  "lisato - branco": "/assets/images/tecidos/lisato-branco.png",

  // Cordas
  "azulões": "/assets/images/cordas/azulao.png",
  "pretas": "/assets/images/cordas/Preto.png",
  "verdes musgo": "/assets/images/cordas/verde-musgo.png",
  "rami": "/assets/images/cordas/rami.png",
  "terracotas": "/assets/images/cordas/terra-cota.png",
  "verdes oliva": "/assets/images/cordas/verde-oliva.png",
  "cinzas": "/assets/images/cordas/cinza.png",
  "azuis turquesa": "/assets/images/cordas/azul-turquesa.png",

  // Fibras
  "verde escuro estonado": "/assets/images/fibras/verde-escuro-estonado.jpg",
  "camurça estonado": "/assets/images/fibras/camura-estonado.jpg",
  "goiaba": "/assets/images/fibras/goiaba.jpg",
  "verde escuro liso": "/assets/images/fibras/verde.jpg",
  "marinho liso": "/assets/images/fibras/marinho.jpg",
  "sepia": "/assets/images/fibras/sepia.jpg",
  "pedra ferro": "/assets/images/fibras/pedra-ferro.jpg",
  "preto": "/assets/images/fibras/preto.jpg",
  "branco": "/assets/images/fibras/branco.jpg",
  "natural": "/assets/images/fibras/natural.png",
  "eucalipto": "/assets/images/fibras/eucalipto.jpg",
  "cumaru": "/assets/images/fibras/cumaru.jpg",
  "carvalho": "/assets/images/fibras/carvalho.jpg",
  "cinza": "/assets/images/fibras/cinza.jpg",
  "chocolate": "/assets/images/fibras/chocolate.jpg",

  // Espumas
  "espuma D33": "/assets/images/no_image.png",
  "espuma D45": "/assets/images/no_image.png",

  // Pinturas
  "marrom ascortem": "/assets/images/no_image.png",
  "champagnhe": "/assets/images/no_image.png",
  "preto microtestura": "/assets/images/no_image.png",
  "fendi": "/assets/images/no_image.png",
  "cinza grafite": "/assets/images/no_image.png",
  "terracota": "/assets/images/no_image.png",

  // Materiais
  "madeira": "/assets/images/madeiras/peroba.jpeg",
  "aço": "/assets/images/no_image.png",
  "aluminio": "/assets/images/no_image.png",
  "vidro": "/assets/images/no_image.png",
  "marmore": "/assets/images/no_image.png",
  "vime": "/assets/images/no_image.png",
  "bambu": "/assets/images/no_image.png",
  "corda": "/assets/images/no_image.png",
  "fibra": "/assets/images/no_image.png",
  "couro": "/assets/images/no_image.png",
  "tecido": "/assets/images/no_image.png",
  "tecido premium": "/assets/images/no_image.png",
  "tecido resistente": "/assets/images/no_image.png",
  "metal": "/assets/images/no_image.png",
};
